import { Component } from '@angular/core';

@Component({
  selector: 'app-settings-course-manage-form',
  standalone: true,
  imports: [],
  templateUrl: './app-settings-course-manage-form.component.html',
  styleUrl: './app-settings-course-manage-form.component.css'
})
export class AppSettingsCourseManageFormComponent {

}
